// Quill rich-text field (main-CMS convention for content fields; react-quill-new
// is the React-19-compatible fork the platform already uses). Dark-theme
// overrides live in index.css under .lms-quill.
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'blockquote'],
    ['clean'],
  ],
};

export default function RichText({ value, onChange, placeholder }) {
  return (
    <div className="lms-quill">
      <ReactQuill theme="snow" value={value || ''} onChange={onChange} modules={MODULES} placeholder={placeholder} />
    </div>
  );
}
